import { ISharedDatasourcesState } from './index';
import { get, entries } from 'lodash';

export const QODLY_NAMESPACE = 'Qodly';
export const LOCATION_DATASOURCE_ID = 'Location';
export const USER_LANGUAGE_DATASOURCE_ID = 'UserLanguage';

export const SHARED_USER_NAMESPACE: ISharedDatasourcesState['sources'] = {
  [QODLY_NAMESPACE]: [
    {
      id: LOCATION_DATASOURCE_ID,
      dataType: 'object',
      type: 'scalar',
      namespace: QODLY_NAMESPACE,
      initialValue: {
        urlQuery: [],
        urlPath: {},
        Anchor: '',
      },
      schema: {
        type: 'object',
        properties: [
          { name: 'urlQuery', type: 'array', initialValue: [] }, // URL segments
          { name: 'urlPath', type: 'object', initialValue: {} }, // Query params
          { name: 'Anchor', type: 'string', initialValue: '' }, // Hash anchor
        ],
      },
    },
    {
      id: USER_LANGUAGE_DATASOURCE_ID,
      dataType: 'object',
      type: 'scalar',
      namespace: QODLY_NAMESPACE,
      initialValue: {
        selected: {},
        supported: [],
      },
      schema: {
        type: 'object',
        properties: [
          { name: 'selected', type: 'object', initialValue: {} },
          { name: 'supported', type: 'array', initialValue: [] },
        ],
      },
    },
  ],
};

const notMatchingAttributes = ['initialValue', 'schema'];

export const sameDefaultUserSource = (
  last: datasources.ICreateDataSource,
  def: datasources.ICreateDataSource,
) => {
  let same = true;

  entries(last)
    .filter(([key]) => !notMatchingAttributes.includes(key))
    .forEach(([key, value]) => {
      if (value !== get(def, key)) {
        same = false;
        return;
      }
    });

  return same;
};
